module.exports = "##### Purple\n"